import { Component, Input, OnInit } from '@angular/core';
import { ILicenca } from 'src/app/shared/api/licencas/licencas.service';
import { IMaterial } from 'src/app/shared/api/testes/adm-materiais.service';
import { IMidia } from 'src/app/shared/api/testes/adm-midias.service';
import { MidiasService } from 'src/app/shared/api/testes/midias.service';
import { ConstantsWidthHeightMidia } from 'src/app/shared/components/card-midia/card-midia-constants';
import { unformatedStringDateToPortugueseDateString } from 'src/app/shared/functions/data-transform';

@Component({
    selector: 'card-material',
    templateUrl: './card-material.component.html',
    styleUrls: ['./card-material.component.scss']
})
export class CardMaterialComponent implements OnInit {
    @Input() material!: IMaterial;
    @Input() licenca!: ILicenca;
    @Input() urlCapa!: string;

    disponivel = false;
    imageLoaded = false;
    midia?: IMidia;
    constantsWidthHeightMidia = ConstantsWidthHeightMidia;

    constructor(private midiaService: MidiasService) {}

    ngOnInit(): void {
        this.setarDisponibilidade();
        this.obterMidiaMaterial();
    }

    private setarDisponibilidade(){
        this.disponivel = this.licenca.data_fim != null;
    }

    private obterMidiaMaterial() {
        const sub = this.midiaService.getMidiasMateriais(this.material.uuid).subscribe({
            next: (response) => {
                sub.unsubscribe();
                this.midia = response.resultados[0];
            }
        });
    }

    get labelAcao() {
        if (!this.disponivel) return 'Indisponível';
        return this.midia?.formato == 'link' ? 'Abrir link' : 'Baixar';
    }

    get iconAcao() {
        if (!this.disponivel) return 'lock';
        return this.midia?.formato == 'link' ? 'open_in_new' : 'download';
    }

    get labelTipoMaterial() {
        if (!this.midia?.formato) return 'Material';
        return this.midia.formato.toLocaleUpperCase();
    }

    converterData(data: string | undefined) {
        if (data == null) return '';
        return unformatedStringDateToPortugueseDateString(data);
    }

    tooltipCadeado() {
        return 'Disponível após concluir o teste';
    }

    iniciar() {
        if (!this.disponivel) return;

        if (this.midia) {
            this.abrirMidia(this.midia);
            return;
        }

        const sub = this.midiaService.getMidiasMateriais(this.material.uuid).subscribe({
            next: (response) => {
                sub.unsubscribe();
                this.midia = response.resultados[0];
                if (this.midia) this.abrirMidia(this.midia);
            }
        });
    }

    private abrirMidia(midia: IMidia) {
        if (midia.formato == 'link') {
            const fullUrl = midia.url!.startsWith('http')
                ? midia.url
                : `https://${midia.url}`;
            window.open(fullUrl, '_blank');
        } else {
            const link = document.createElement('a');
            link.href = midia.url!;
            link.download = 'download';
            link.click();
        }
    }

    loadImage() {
        this.imageLoaded = true;
    }
}
